/**
 * Angular DevTools — Angular debugging DevTools panel
 *
 * Declares two web-accessible resources, `app/backend_bundle.js` and
 * `app/detect_angular_bundle.js`, matched to `<all_urls>` with no `use_dynamic_url` —
 * so both are served at a fixed URL to any page. The `detect_angular_bundle.js` name is
 * vendor-specific, making the fetch conclusive when it succeeds.
 *
 * Manifest verified against version 1.17.0.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'ienfalfjdbdpebioblfackkekamfmbnh';

export const angularDevtools: ExtensionDefinition = {
  id: ID,
  name: 'Angular DevTools',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 400_000,
  notes:
    'Two static WAR on <all_urls> with no dynamic URL. The vendor-named ' +
    'detect_angular_bundle.js makes detection a single conclusive fetch.',
  signals: [
    {
      id: 'war-detect-angular-bundle-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch app/detect_angular_bundle.js — a vendor-named detection bundle exposed to ' +
        'every origin at a fixed URL, distinctive to Angular DevTools.',
      weight: 1,
      run: () => probeFetch(ID, 'app/detect_angular_bundle.js'),
    },
    {
      id: 'war-backend-bundle-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch app/backend_bundle.js — the second exposed bundle, an independent ' +
        'corroborating path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'app/backend_bundle.js'),
    },
  ],
};
